import { render, staticRenderFns } from "./menu-instituicao.vue?vue&type=template&id=c353cc60&scoped=true&"
import script from "./menu-instituicao.vue?vue&type=script&lang=js&"
export * from "./menu-instituicao.vue?vue&type=script&lang=js&"
import style0 from "./menu-instituicao.vue?vue&type=style&index=0&id=c353cc60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c353cc60",
  null
  
)

export default component.exports